(function () {
  'use strict';

  function initCcg(id) {
    if (!id) return;

    var results = document.getElementById('ccg-results-' + id);
    if (!results) return;
    if (results.dataset.ccgInit === '1') return;
    results.dataset.ccgInit = '1';

    var sortEl = document.getElementById('ccg-sort-' + id);
    var toggle = document.getElementById('ccg-filter-toggle-' + id);
    var close = document.getElementById('ccg-filter-close-' + id);
    var panel = document.getElementById('ccg-filter-panel-' + id);
    var overlay = document.getElementById('ccg-filter-overlay-' + id);

    /* ── AJAX fetch results ────────────────────────────────────
       Updates the URL via pushState, fetches the new page,
       swaps only the #ccg-results-* container — no full reload.
    ──────────────────────────────────────────────────────────── */
    function fetchResults(url) {
      results.classList.add('ccg-results--loading');

      history.pushState({ ccg: true }, '', url);

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.getElementById('ccg-results-' + id);
          if (fresh) {
            results.innerHTML = fresh.innerHTML;
            attachResultHandlers();
          }
          /* Sync sort dropdown to the new URL */
          var params = new URL(url).searchParams;
          var sortVal = params.get('sort_by');
          if (sortEl && sortVal) sortEl.value = sortVal;

          results.classList.remove('ccg-results--loading');
          closePanel();
        })
        .catch(function () {
          results.classList.remove('ccg-results--loading');
        });
    }

    /* ── Build URL from filter form ────────────────────────── */
    function buildFilterURL() {
      var form = document.getElementById('ccg-filter-form-' + id);
      var url = new URL(window.location.href);

      if (!form) return url.toString();

      /* Remove all current filter params */
      var allInputs = form.querySelectorAll('input[type="checkbox"], input[type="number"]');
      var cleared = [];
      allInputs.forEach(function (inp) {
        if (inp.name && cleared.indexOf(inp.name) === -1) {
          url.searchParams.delete(inp.name);
          cleared.push(inp.name);
        }
      });

      /* Add checked checkboxes */
      form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        url.searchParams.append(cb.name, cb.value);
      });

      /* Add price range */
      form.querySelectorAll('input[type="number"]').forEach(function (inp) {
        if (inp.value !== '') url.searchParams.set(inp.name, inp.value);
      });

      /* Preserve sort */
      if (sortEl && sortEl.value) url.searchParams.set('sort_by', sortEl.value);

      /* Reset to page 1 when filters change */
      url.searchParams.delete('page');

      return url.toString();
    }

    /* ── Attach handlers inside the results container ──────── */
    function attachResultHandlers() {
      /* Active filter tag remove links */
      results.querySelectorAll('.ccg-active-filter-tag, .ccg-clear-all').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          fetchResults(this.href);
        });
      });

      /* Pagination links */
      results.querySelectorAll('.ccg-page-btn[href]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          fetchResults(this.href);
        });
      });
    }

    /* ── Sort change ───────────────────────────────────────── */
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        fetchResults(url.toString());
      });
    }

    /* ── Apply filters button ──────────────────────────────── */
    var applyBtn = document.getElementById('ccg-filter-apply-' + id);
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        fetchResults(buildFilterURL());
      });
    }

    /* ── Instant filter on checkbox click ─────────────────── */
    var form = document.getElementById('ccg-filter-form-' + id);
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') {
          fetchResults(buildFilterURL());
        }
      });
    }

    /* ── Filter panel open / close ─────────────────────────── */
    function openPanel() {
      panel.classList.add('is-open');
      overlay.classList.add('is-visible');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closePanel() {
      if (!panel) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (toggle) toggle.addEventListener('click', openPanel);
    if (close) close.addEventListener('click', closePanel);
    if (overlay) overlay.addEventListener('click', closePanel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) {
        closePanel();
        if (toggle) toggle.focus();
      }
    });

    /* ── Browser back / forward ────────────────────────────── */
    window.addEventListener('popstate', function () {
      fetchResults(window.location.href);
    });

    /* ── Init ──────────────────────────────────────────────── */
    attachResultHandlers();
  }

  function initAll() {
    document.querySelectorAll('.ccg-section[data-section-id]').forEach(function (el) {
      initCcg(el.getAttribute('data-section-id'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-initialize when Shopify re-renders the section in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.ccg-section[data-section-id]');
    if (el) initCcg(el.getAttribute('data-section-id'));
  });
})();
